import React, {createContext, useEffect} from "react";
import PropTypes from "prop-types";
import JssProvider from "react-jss/lib/JssProvider";
import {
  MuiThemeProvider,
  createMuiTheme,
  createGenerateClassName
} from "@material-ui/core/styles";
import {defaultState} from "./defaultState";
import {disabledSearchPages} from "./config";
import {Pane} from "./components/Pane";
import {Header} from "./components/Header";
import {StickyHeader} from "./components/StickyHeader";

import styles from "./header.module.scss";

export const Context = createContext(defaultState);

export default function App({state, materialUI}) {
  const theme = createMuiTheme({
    typography: {
      fontFamily: `"Formular", "Arial", sans-serif`,
      useNextVariants: true
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 740,
        md: 940,
        lg: 1240,
        xl: 1440
      }
    }
  });

  const generateClassName = createGenerateClassName({
    productionPrefix: `${materialUI}-react-app`
  });

  useEffect(() => {
    const jssStyles = document.getElementById(`jss-server-side-${materialUI}`);
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, [materialUI]);

  const isStickyHeaderDisabled = disabledSearchPages.some((regexp) =>
    regexp.test(state.fullpath)
  );

  return (
    <JssProvider generateClassName={generateClassName}>
      <MuiThemeProvider theme={theme}>
        <Context.Provider value={{...defaultState, ...state}}>
          <header className={styles.container}>
            <Pane />
            {!isStickyHeaderDisabled && <StickyHeader />}
            <Header />
          </header>
        </Context.Provider>
      </MuiThemeProvider>
    </JssProvider>
  );
}

App.propTypes = {
  materialUI: PropTypes.string,
  state: PropTypes.shape({
    authenticityToken: PropTypes.string,
    fullpath: PropTypes.string,
    user: PropTypes.shape({
      name: PropTypes.string,
      admin: PropTypes.bool
    }),
    cartItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        type: PropTypes.string,
        price: PropTypes.number,
        amount: PropTypes.number,
        picture: PropTypes.string,
        removeLink: PropTypes.string
      })
    ),
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        path: PropTypes.string,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            path: PropTypes.string,
            children: PropTypes.arrayOf(
              PropTypes.shape({
                title: PropTypes.string,
                path: PropTypes.string
              })
            )
          })
        )
      })
    )
  })
};
